export default __webpack_public_path__ + "static/media/landscape8.04ac2a38.jpeg";